import React from 'react';
import LoginRegisterLayout from '../../../components/Shop/StoreLayout/Layout/LoginRegisterLayout';
import Login from './Login';
import messages from '../../../locale/messages';

const title = 'Log In';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.login);

    // From Redux Store
    let isAuthenticated = store.getState().user.store;

    if (isAuthenticated) {
        return { redirect: '/store/dashboard' };
    }

    return {
        title,
        component: <LoginRegisterLayout><Login title={title} /></LoginRegisterLayout>
    }
}

export default action;
